export const getStaticContentUrl = (): string => process.env.REACT_APP_STATIC_CONTENT_URL ?? '';
